
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class B2CGrid extends Serenity.EntityGrid<B2CRow, any> {
        protected getColumnsKey() { return B2CColumns.columnsKey; }
        protected getDialogType() { return B2CDialog; }
        protected getIdProperty() { return B2CRow.idProperty; }
        protected getInsertPermission() { return B2CRow.insertPermission; }
        protected getLocalTextPrefix() { return B2CRow.localTextPrefix; }
        protected getService() { return B2CService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: B2CService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));


            return buttons;

        }
    }
}